import { jsx, jsxs } from "react/jsx-runtime";
import * as LucideIcons from "@tamagui/lucide-icons";
import { useMemo, useState } from "react";
import { ScrollView } from "react-native";
import { Grid, Input, Paragraph, Spacer, YStack, useDebounceValue } from "tamagui";
const lucideIcons = Object.keys(LucideIcons).map((name) => ({
  key: name.toLowerCase(),
  name,
  Icon: LucideIcons[name]
}));
function LucideIconsDemo() {
  const [searchRaw, setSearch] = useState("");
  const search = useDebounceValue(searchRaw, 400);
  const size = 100;
  const iconsMemo = useMemo(
    () => lucideIcons.filter((x) => x.key.startsWith(search.toLowerCase())).map(({ Icon, name }) => /* @__PURE__ */ jsxs(
      YStack,
      {
        height: size + 20,
        alignItems: "center",
        justifyContent: "center",
        children: [
          /* @__PURE__ */ jsx(Icon, { size: size * 0.25 }),
          /* @__PURE__ */ jsx(Spacer, {}),
          /* @__PURE__ */ jsx(
            Paragraph,
            {
              height: "$6",
              wordWrap: "break-word",
              maxWidth: "100%",
              textAlign: "center",
              paddingHorizontal: "$2",
              size: "$1",
              opacity: 0.5,
              children: name
            }
          )
        ]
      },
      name
    )),
    [search]
  );
  return /* @__PURE__ */ jsxs(YStack, { minWidth: "100%", padding: "$4", paddingBottom: "$0", space: true, children: [
    /* @__PURE__ */ jsx(Input, { value: searchRaw, onChangeText: setSearch, placeholder: "Search..." }),
    /* @__PURE__ */ jsx(YStack, { height: 420, children: /* @__PURE__ */ jsx(ScrollView, { children: /* @__PURE__ */ jsx(Grid, { itemMinWidth: size, children: iconsMemo }) }) })
  ] });
}
export {
  LucideIconsDemo
};
//# sourceMappingURL=LucideIconsDemo.js.map
